module.exports = __webpack_public_path__ + "img/Z60Q_01.465dd403.jpg";